/**
 * Keep zoom / rotation pivoted on the crop canvas center (not the media center).
 *
 * react-easy-crop applies `translate(crop) rotate(θ) scale(z)` with transform-origin
 * on the media. When crop ≠ {0,0}, changing zoom or rotation alone spins/scales around
 * the image center. Compensating crop keeps the point under the canvas center fixed.
 */

/**
 * @param {{ x: number, y: number }} crop
 * @param {number} deltaDegrees rotation applied to the media (CSS degrees, clockwise)
 * @returns {{ x: number, y: number }}
 */
export function rotateCropAroundCanvasCenter(crop, deltaDegrees) {
  if (!crop || !Number.isFinite(deltaDegrees) || deltaDegrees === 0) {
    return crop ?? { x: 0, y: 0 };
  }
  const rad = (deltaDegrees * Math.PI) / 180;
  const cos = Math.cos(rad);
  const sin = Math.sin(rad);
  return {
    x: crop.x * cos - crop.y * sin,
    y: crop.x * sin + crop.y * cos,
  };
}

/**
 * Shortest signed delta from `from` to `to` in degrees (result in (-180, 180]).
 * @param {number} from
 * @param {number} to
 * @returns {number}
 */
export function shortestRotationDelta(from, to) {
  return ((((to - from) % 360) + 540) % 360) - 180;
}

/**
 * @param {number} degrees
 * @returns {number}
 */
export function normalizeRotationDegrees(degrees) {
  return ((degrees % 360) + 360) % 360;
}
